import { gql } from "@apollo/client"

export const ADVANCED_SEARCH = gql`
  query AdvancedSearch(
    $staff_id: ID!
    $organization_id: ID!
    $participant_alias: String
    $participant_full_name: String
    $participant_name_preferred: String
    $participant_phone_primary: String
    $participant_email_account: String
    $participant_city_primary: String
    $participant_state_primary: String
    $participant_zip_code_primary: String
    $program_ids: [String]
    $participant_membership_status: [String]
    $staff_full_name: String
    $staff_ids: [String]
    $locations_ids: [String]
    $search_type: String
  ) {
    search: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_alias: $participant_alias
      participant_full_name: $participant_full_name
      participant_name_preferred: $participant_name_preferred
      participant_phone_primary: $participant_phone_primary
      participant_email_account: $participant_email_account
      participant_city_primary: $participant_city_primary
      participant_state_primary: $participant_state_primary
      participant_zip_code_primary: $participant_zip_code_primary
      program_ids: $program_ids
      participant_membership_status: $participant_membership_status
      staff_full_name: $staff_full_name
      staff_ids: $staff_ids
      locations_ids: $locations_ids
      search_type: $search_type
    ) {
      participant_id
      participant_alias
      participant_membership_status
      participant_name_first
      participant_name_last
      participant_phone_primary
      participant_email_account
      program_list
      participant_last_engagement
      participant_last_activity
      id_participant_last_activity
      current_rsi
      staff_full_name
      locations
      __typename
    }
  }
`

export const PROGRAM_ID_LIST = gql`
  query GetProgramIdList($staff_id: ID!, $organization_id: ID!) {
    programs(staff_id: $staff_id, organization_id: $organization_id) {
      program_identity_id
      program_id_name
    }
  }
`
export const GET_PARTICIPANTS = gql`
  query ParticipantField(
    $staff_id: ID!
    $organization_id: ID!
    $participant_alias: String
    $participant_name_first: String
    $participant_name_last: String
    $participant_name_preferred: String
    $participant_phone_primary: String
    $participant_email_account: String
    $participant_city_primary: String
    $participant_state_primary: String
    $participant_zip_code_primary: String
    $program_ids: [String]
    $participant_membership_status: [String]
  ) {
    participants(
      staff_id: $staff_id
      organization_id: $organization_id
      participant_alias: $participant_alias
      participant_name_first: $participant_name_first
      participant_name_last: $participant_name_last
      participant_name_preferred: $participant_name_preferred
      participant_phone_primary: $participant_phone_primary
      participant_email_account: $participant_email_account
      participant_city_primary: $participant_city_primary
      participant_state_primary: $participant_state_primary
      participant_zip_code_primary: $participant_zip_code_primary
      program_ids: $program_ids
      participant_membership_status: $participant_membership_status
    ) {
      participant_id
      participant_alias
      participant_membership_status
      participant_name_first
      participant_name_last
      participant_phone_primary
      participant_email_account
      program_list
      participant_last_engagement
      participant_last_activity
      current_rsi
    }
  }
`

export const GET_LOCATIONS = gql`
  query GetLocationsIdList($staff_id: ID!, $organization_id: ID!) {
    locationsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      location_id
      location_name
    }
  }
`

export const GET_STAFFS_BY_ORG = gql`
  query getStaffList($staff_id: ID!, $organization_id: ID!) {
    staffsByOrganization: staffMembersByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      staff_id
      staff_name_first
      staff_name_last
    }
  }
`
